export const normalizeContainer = (container) => ({
  x: container.x || container.pos?.x || 0,
  y: container.y || container.pos?.y || 0,
  width: container.width || container.size?.width || 0,
  height: container.height || container.size?.height || 0,
  padding: container.padding || 0,
});

const normalizeSize = (size) => ({
  width: size?.width || size?.size?.width || 0,
  height: size?.height || size?.size?.height || 0,
});

export const HPOS = {
  LEFT: "left",
  MIDDLE: "middle",
  RIGHT: "right",
};

export const VPOS = {
  TOP: "top",
  CENTER: "center",
  BOTTOM: "bottom",
};

export const coord = {
  x: {
    left: (container) => {
      container = normalizeContainer(container);
      return container.x + container.padding;
    },
    middle: (container, size) => {
      size = normalizeSize(size);
      container = normalizeContainer(container);
      return container.x + (container.width - size.width) / 2;
    },
    right: (container, size) => {
      size = normalizeSize(size);
      container = normalizeContainer(container);
      return container.x + container.width - size.width - container.padding;
    },
  },
  y: {
    top: (container) => {
      container = normalizeContainer(container);
      return container.y + container.padding;
    },
    center: (container, size) => {
      size = normalizeSize(size);
      container = normalizeContainer(container);
      return container.y + (container.height - size.height) / 2;
    },
    bottom: (container, size) => {
      size = normalizeSize(size);
      container = normalizeContainer(container);
      return container.y + container.height - size.height - container.padding;
    },
  },
};

export const getPositionedBox = (
  container,
  size,
  vPos,
  hPos,
  offset = { x: 0, y: 0 }
) => {
  const x = coord.x[hPos](container, size) + offset.x;
  const y = coord.y[vPos](container, size) + offset.y;

  return { ...size, x, y };
};

export const getPositionedCircle = (
  container,
  radius,
  vPos,
  hPos,
  offset = { x: 0, y: 0 }
) => {
  const size = { width: radius * 2, height: radius * 2 };

  let { x, y } = getPositionedBox(container, size, vPos, hPos, offset);
  x += radius;
  y += radius;

  return { radius, x, y };
};

export const getPositionedText = (
  container,
  label,
  vPos,
  hPos,
  offset = { x: 0, y: 0 }
) => {
  label = label || "";
  const textMagic = {
    width: 6,
    height: 10,
  };

  const size = {
    width: textMagic.width * label.length,
    height: textMagic.height,
  };

  let { x, y } = getPositionedBox(container, size, vPos, hPos, offset);

  return { x, y, text: label };
};

export const getPositionedIcon = (
  container,
  size,
  vPos,
  hPos,
  offset = { x: 0, y: 0 }
) => {
  const containerHeight =
    normalizeContainer(container).height -
    2 * normalizeContainer(container).padding;
  size = normalizeSize(size);
  const iconHeight = size.height;
  const scale = Math.min(1, containerHeight / iconHeight);
  size = {
    width: size.width * scale,
    height: size.height * scale,
  };

  let { x, y } = getPositionedBox(container, size, vPos, hPos, offset);

  return { x, y, scaleX: scale, scaleY: scale };
};
